// __CARGO_V2__ (2026-10-27) the cargo type on the hauling board: two drop-downs - the CATEGORY, then the TYPE in it -
// from the hub's cargo list (Settings -> General -> Cargo types), as on the booking form and in the apps. A job's
// old name ("Skidsteer") shows under the category of the type it maps to and is kept unless a type is picked. When the
// hub cannot be reached and no list was ever kept here, it is the free-text box it was.
import React, { useEffect, useState } from 'react';
import { loadCargoVocab, cargoVocabNow, categoryOf, itemOf } from '../services/hubCargo';

export default function CargoPicker({ value, onChange, style, required }) {
  const [vocab, setVocab] = useState(cargoVocabNow());
  const [cat, setCat] = useState('');
  useEffect(() => {
    let live = true;
    loadCargoVocab().then((v) => { if (live && v) setVocab(v); }).catch(() => {});
    return () => { live = false; };
  }, []);
  const set = (v) => onChange({ target: { name: 'commodity', value: v } });
  if (!vocab || !vocab.groups || !vocab.groups.length) {
    return <input type="text" name="commodity" value={value || ''} onChange={(e) => set(e.target.value)} required={required}
      placeholder="e.g., Skid steer, Assorted lumber" style={style} />;
  }
  const item = itemOf(vocab, value);
  const shownCat = (item && categoryOf(vocab, item)) || cat;
  const group = vocab.groups.find((g) => g.name === shownCat) || null;
  const exact = item && String(value || '').trim() === item;
  return (
    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
      <select aria-label="Cargo category" value={shownCat || ''} style={{ ...style, flex: '1 1 10rem', width: 'auto' }}
        onChange={(e) => { setCat(e.target.value); if (item && categoryOf(vocab, item) !== e.target.value) set(''); }}>
        <option value="">-- Category --</option>
        {vocab.groups.map((g) => <option key={g.name} value={g.name}>{g.name}</option>)}
      </select>
      <select aria-label="Cargo type" name="commodity" required={required} value={value || ''} disabled={!group && !value}
        style={{ ...style, flex: '2 1 14rem', width: 'auto' }} onChange={(e) => set(e.target.value)}>
        <option value="">{group ? '-- Type --' : '-- pick a category first --'}</option>
        {value && !exact ? <option value={value}>{value}{item ? ` (old name of ${item})` : ' (not on the list)'}</option> : null}
        {(group ? group.items : []).map((i) => <option key={i} value={i}>{i}</option>)}
      </select>
    </div>
  );
}
